import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Shared Vitria application canvas.
 *
 * The original component rendered hundreds of random DOM nodes on every
 * resize. The new canvas is deterministic, lighter, and deliberately echoes
 * the editorial glow and fine grid used on the landing page.
 */
const SciFiBackground = ({ children, className = '' }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`sci-fi-background vitria-app-canvas ${isDarkMode ? 'dark' : 'light'} ${className}`.trim()}>
      <div className="vitria-canvas-atmosphere" aria-hidden="true">
        <span className="vitria-orb vitria-orb-violet" />
        <span className="vitria-orb vitria-orb-coral" />
        <span className="vitria-orb vitria-orb-blue" />
        <span className="vitria-canvas-grid" />
        <span className="vitria-canvas-noise" />
      </div>
      <div className="vitria-canvas-content">{children}</div>
    </div>
  );
};

export default SciFiBackground;
